import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { Image, Link, Markdown } from "components";
import { Pricing5Content } from "types/graphql/generated";

type Pricing5BottomContent = Pick<
  Pricing5Content,
  "pricing5CostGetBackLabel" | "pricing5CostGetBackLink" | "pricing5CostGetBackIcon"
>;

interface Props {
  content: Pricing5BottomContent;
}

const Pricing5BottomSection: FC<Props> = withErrorBoundary(
  ({ content: { pricing5CostGetBackLabel, pricing5CostGetBackLink, pricing5CostGetBackIcon } }) => {
    return (
      <StyledPricing5BottomSection className="m-auto mx-8 max-w-container">
        {pricing5CostGetBackLink ? (
          <Link href={pricing5CostGetBackLink} className="Pricing5__getBack Pricing5__getBackLink">
            {pricing5CostGetBackIcon?.data?.image && (
              <Image className="Pricing5__getBackIcon" {...pricing5CostGetBackIcon.data.image} width={40} height={40} />
            )}

            <Markdown className="Pricing5__getBackLabel Font_18_26_450">{pricing5CostGetBackLabel}</Markdown>
          </Link>
        ) : (
          <div className="Pricing5__getBack">
            {pricing5CostGetBackIcon?.data?.image && (
              <Image className="Pricing5__getBackIcon" {...pricing5CostGetBackIcon.data.image} width={40} height={40} />
            )}

            <Markdown className="Pricing5__getBackLabel Font_18_26_450">{pricing5CostGetBackLabel}</Markdown>
          </div>
        )}
      </StyledPricing5BottomSection>
    );
  },
  {}
);

const StyledPricing5BottomSection = styled.div`
  margin-top: 24px;

  .Pricing5__getBack {
    width: 100%;
    display: flex;
    padding: 20px 24px;
    border-radius: 40px;
    background: rgb(255 255 255 / 50%);
    align-items: center;
  }

  .Pricing5__getBackLink {
    &:hover {
      background: rgb(255 255 255 / 75%);
    }
  }

  .Pricing5__getBackIcon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
  }

  .Pricing5__getBackLabel {
    margin-left: 16px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Pricing5__getBack {
      border-radius: 8px;
    }

    .Pricing5__getBackIcon {
      align-self: flex-start;
    }
  }
`;

export { Pricing5BottomSection };
